import React, { PureComponent } from "react";
import { Checkmark16Regular } from "@fluentui/react-icons";
import { If } from '../../../core/components/If';

interface IBooleanReadonlyDisplayProps {
    value: boolean
}


export default class BooleanReadonlyDisplay extends PureComponent<
    IBooleanReadonlyDisplayProps
    > {
    constructor(props) {
        super(props);
    }

    render() {
        const { value } = this.props;
        return (
            <div>
                <If condition={value}>
                    <Checkmark16Regular className="icon node-icon" />
                </If>
                {value && value !== null ? value?.valueOf().toString().replace(/true/gi, "Yes").replace(/false/gi, "No") : "No"}
            </div>
        );
    }
}
